import styled from 'styled-components';
import color from '../../../config/colors.json';
import BannerTabletBg from '../../../img/banner_tablet.png';
import ScreenSize from '../../../config/screenSizes.json';
import elipse from '../../../img/elipse.png';

export const BannerBackground = styled.div`
    height: 259px;
    background-color: #2F3132;
    border-radius: 5px;
    position: relative;
    padding-left: 34px;
    background-image: url('${elipse}');
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: calc(100% - 200px) 100%;

    img {
        margin-top: 49px;
        margin-right: 10px;
        float: right;
    }

    @media screen and (max-width: 1919px) {
    height: 190px;
    }

    @media screen and (max-width: ${ScreenSize.tablet}px) {
        background-image: none;
        height: 150px;
        background-image: url('${elipse}');
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: calc(100% - 110px) 100%;
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        background-image: none;
        height: 150px;
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: calc(100% - 110px) 100%;
    }
`;

export const Banner = styled.div`
    position: relative;
    padding: 21px 33px;
    border-radius: 5px;
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        background-image: url('${BannerTabletBg}');
        background-size: auto;
        background-position: top right;
    }
`;

export const MainText = styled.h1`
    color: ${color.light};
    font-size: 27px;
    line-height: 37px;
    font-weight: bold;
    font-family: 'Poppins', sans-serif;
    @media screen and (max-width: 1919px) {
    font-size: 24px;
    line-height: 35px;
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
    font-size: 18px;
    line-height: 20px;
  }
`;

export const Title = styled.h1`
    font-size: 25px;
    line-height: 49px;
    text-transform: uppercase;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: ${color.light};
    margin-bottom: 20px;
    position: relative;
    &:after {
        content: '';
        display: table;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 113px;
        height: 3px;
        background-color: ${color.lightRed};
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 28px;
        margin-bottom: 25px;
    }
`;

export const Text = styled.em`
    margin-bottom: 18px;
    display: block;
    font-style: normal;
    font-weight: lighter;
    font-size: 21px;
    line-height: 31px;
    font-family: 'Poppins', sans-serif;
    color: ${color.silver};
    @media screen and (max-width: 1919px) {
    font-size: 20px;
    margin-bottom: 0;
    line-height: 30px;
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 12px;
        line-height: 20px;
        margin-bottom: 20px;
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 0;
    }
`;

export const CarImg = styled.img`
    position: absolute;
    top: ${({ top }) => top};
    right: ${({ right }) => right};
    z-index: 1;
    &:nth-of-type(1) {
        top: 0;
        right: 400px;
     }
     &:nth-of-type(2) {
        top: 30px;
        right: 83px;
        width: 33%;
     }
    @media screen and (max-width: 1919px) {
    width: 33%;
    &:nth-of-type(1) {
        top: 0;
        right: 226px;
     }
     &:nth-of-type(2) {
        top: 17px;
        right: 0;
     }
  }  
  @media screen and (max-width: ${ScreenSize.tablet}px) {
    width: 27%;
    &:nth-of-type(1) {
        top: 10px;
        right: 150px;
     }
     &:nth-of-type(2) {
        top: 30px;
        right: 39px;
     }
  }
  @media screen and (max-width: ${ScreenSize.portrait}px) {
    display: none;
  }
`;
